import React from 'react';
import './DoctorHeroSection.css';
import { Link } from "react-router-dom";
function DoctorHeroSection() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Physician",
    "name": "Dr. B. Shruti Sagar",
    "image": "https://i.ibb.co/VYmQ8jXQ/Save-Clip-App-469483120-17864062791277450-3833299510464549824-n-1.png",
    "medicalSpecialty": "Gastroenterology, Hepatology",
    "url": "https://krisara-gastro.web.app/", // your website URL
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500014",
      "addressCountry": "IN"
    },
    "telephone": "+917569541532",
    "sameAs": [
      "https://www.facebook.com/yourprofile",
      "https://www.instagram.com/yourprofile",
      "https://www.linkedin.com/in/yourprofile"
    ],
    "award": "500+ advanced ERCPs & 300+ EUS procedures",
    "description": "Leading Gastroenterologist & Hepatologist in Kompally, Hyderabad with 8 years of clinical and procedural experience."
  };
  return (
    <section className="doctor-hero">
      <div className="doctor-hero__overlay">
        <div className="doctor-hero__content">
          {/* Left Content */}
          <div className="doctor-hero__text">
            <h1 className="doctor-hero__title">
              Meet Dr. B. Shruti Sagar
            </h1>
            <p className="doctor-hero__subtitle">
              Leading Gastroenterologist & Hepatologist in Kompally, Hyderabad
            </p>
            <div className="doctor-hero__buttons">
              <Link to="/services" className="btn btn--dark">
                Know More →
              </Link>
              <Link to="/appointment" className="btn btn--primary">
                Book Appointment
              </Link>
            </div>
          </div>
          {/* Right Content (Doctor Card) */}
          <div className="doctor-hero__card">
            <img
              src="https://i.ibb.co/VYmQ8jXQ/Save-Clip-App-469483120-17864062791277450-3833299510464549824-n-1.png"
              alt="Dr. Shruthi Sagar- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
              className="doctor-hero__image"/>
            <div className="doctor-hero__card-info">
              <h3 className="doctor-hero__name">Dr. Shruti Sagar <span>MBBS, MD, DM</span></h3>
              <p className="doctor-hero__desc">
                Best Gastroenterologist in Kompally, Hyderabad
                8 years of clinical and procedural experience
                500+ advanced ERCPs & 300+ EUS procedures
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </section>
  );
}
export default DoctorHeroSection;